import { getLogger } from '../../libs/logger/frontend.logger';

const LCP_LOG_MESSAGE = 'frontend.web_vitals.lcp';

function isFirstPaintLcpSupported(): boolean {
  try {
    return (
      typeof PerformanceObserver !== 'undefined' &&
      PerformanceObserver.supportedEntryTypes !== undefined &&
      PerformanceObserver.supportedEntryTypes.includes(
        'largest-contentful-paint',
      )
    );
  } catch {
    return false;
  }
}

/**
 * Registers a PerformanceObserver for the initial document LCP and logs one
 * structured event to Browser Logs when the page is hidden (unload / background tab).
 * Runs once when this module is loaded. No-op when the API is unavailable. Does not use RUM.
 */
function registerFirstPaintLcpReporting(): void {
  if (!isFirstPaintLcpSupported()) {
    return;
  }

  let lastEntry: PerformanceEntry | undefined;
  let reported = false;

  const report = (): void => {
    if (reported || lastEntry === undefined) {
      return;
    }
    reported = true;

    const context: Record<string, unknown> = {
      lcp_ms: Math.round(lastEntry.startTime),
    };

    if (
      'size' in lastEntry &&
      typeof (lastEntry as { size?: unknown }).size === 'number'
    ) {
      context['lcp_size'] = (lastEntry as { size: number }).size;
    }

    const elementId = (lastEntry as { id?: unknown }).id;
    if (typeof elementId === 'string' && elementId !== '') {
      context['lcp_id'] = elementId;
    }

    getLogger('web-vitals').info(LCP_LOG_MESSAGE, context);
  };

  try {
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      if (entries.length > 0) {
        lastEntry = entries[entries.length - 1];
      }
    });
    observer.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch {
    return;
  }

  window.addEventListener('pagehide', report);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      report();
    }
  });
}

registerFirstPaintLcpReporting();

export {};
